declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

const GA_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;

/**
 * Sends a page_view hit to Google Analytics.
 * No-op when REACT_APP_GA_MEASUREMENT_ID is not set (i.e. non-production builds).
 */
export function trackPageView(path: string): void {
  if (!GA_ID || typeof window.gtag !== "function") return;
  window.gtag("event", "page_view", {
    page_path: path,
    send_to: GA_ID,
  });
}
